export interface GetDocumentListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetDocumentListPagingAndFilterResponseData
}

export interface GetDocumentListPagingAndFilterResponseData {
    items: GetDocumentListPagingAndFilterResponseItem[]
    totalRecordCount: number
}

export interface GetDocumentListPagingAndFilterResponseItem {
    documentId: string
    menuId: string
    name: string
    isCustomActive: boolean
    companyName: any
    menuName: string
    createdDate: string
    createdUser: string
    updatedDate: string
    updatedUser: string
    isSelected: boolean
}

export const initialGetDocumentListPagingAndFilterResponseData: GetDocumentListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0
}